module.exports = __webpack_public_path__ + "img/thumb_28.a245236a.jpg";